import React, { FC } from "react";
import { FormHelperText, Grid, InputLabel } from "@mui/material";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs"; // Use AdapterDayjs or the appropriate adapter
import { FormFieldProps } from "../../../utils/formFields";
import useStyles from "../../../components/common/model/styles";
import dayjs from "dayjs";
import FormTextField from "./FormTextField";
import moment from "moment";

const DateRangeFieldNew: FC<FormFieldProps> = (props) => {
  const classes = useStyles();

  const handleDateChange = (date: any) => {
    const event = {
      target: {
        id: props.id,
        value: date ? date.toISOString() : null // Convert Day.js object to ISO string
      }
    };
    props?.onChange?.(event);
  };
  
  const inputRender = () => (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
        <div className="dateRangeReadonly">
            <FormTextField
                {...props}
                placeholder="DD/MM/YYYY - DD/MM/YYYY"
                value={`${props?.value ? moment(props?.value).format("DD/MM/YYYY") : 'DD/MM/YYYY'} - ${props?.value && props?.renewsOn ? props?.renewsOn : 'DD/MM/YYYY'}`}
                label=""
                {...{
                    disabled: true
                }}
            />
        </div>
      <DatePicker
        sx={{ width: "100%", background: "transparent" }}
        {
          ...props?.value && {value: dayjs(props?.value)}
        }
        format="DD/MM/YYYY"
        disablePast={props?.disablePast || false}
        disabled={props?.disabled || false}
        // label="DD/MM/YYYY"
        onChange={handleDateChange}
        slotProps={{
          textField: {
            size: "small",
            InputProps: {
              readOnly: true,
              sx: {
                height: "36px",
                border: props.error ? "1px solid #d32f2f" : undefined,
              },
            },
          },
        }}
      />
      {props.error && <FormHelperText sx={{color:'#d32f2f',marginLeft:'14px'}}>{props.helperText}</FormHelperText>}
    </LocalizationProvider>
  );

  return (
    <>
      {props?.label ? (
        <>
          <Grid item xs={12} sm={props?.md ? (props?.firstColmd ? props?.firstColmd : 1.5) : 5} className={classes.labelBox} sx={{ marginTop: props?.isNonMarginTop ? "0px !important" : "" }}>
            <InputLabel
              sx={{color:'#333333', fontWeight: 600, fontSize: "18px" }}
              shrink
              htmlFor={props?.id}
            >
              {props?.label}{props?.isRequired &&<span style={{color:'red',fontWeight:500}}>*</span> }
            </InputLabel>
          </Grid>
          <Grid
            item
            xs={12}
            sm={props?.md ? props?.md : 7}
            style={{
              padding: "0px",
              marginTop: props?.isNonMarginTop ? "0px" : "16px",marginBottom: "10px",
              position: 'relative'
            }}
            className="dateRangeGrid"
          >
            {inputRender()}
          </Grid>
        </>
      ) : (
        inputRender()
      )}
    </>
  );
};

export default DateRangeFieldNew;
